// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LFFN","left":"styles_left__YS6Ey","right":"styles_right__GfHkt","alert":"styles_alert__33Cp0"};